// English source text is also the fallback for unsupported or new messages.
export const commonMessages: Record<string, string> = {
  'TOGAPhotos Account': 'TOGAPhotos 账号',
  'TOGAPhotos home': 'TOGAPhotos 首页',
  'Language': '语言',
  'Sign in': '登录',
  'Continue with your TOGAPhotos account.': '使用你的 TOGAPhotos 账号继续。',
  'Create your account': '创建账号',
  'We will send a code to verify your email address.': '我们会发送验证码以验证你的邮箱。',
  'Create account': '创建账号',
  'Reset your password': '重置密码',
  'Enter your email address to receive a recovery code.': '输入邮箱以接收密码重置验证码。',
  'Continue': '继续',
  'Verify your email': '验证邮箱',
  'Enter the code from your email, or request a new one.': '输入邮件中的验证码，或重新获取验证码。',
  'Verify email': '验证邮箱',
  'Account settings': '账号设置',
  'Update your password and account information.': '更新密码和账号信息。',
  'Save changes': '保存更改',
  'Please sign in again to continue.': '请重新登录以继续。',
  'Preparing your sign-in form…': '正在准备登录表单…',
  'Preparing your form…': '正在准备表单…',
  'Please wait…': '请稍候…',
  'Password': '密码',
  'Profile': '个人资料',
  'Passkeys': '通行密钥',
  'Sign in with a Passkey': '使用通行密钥登录',
  'Add Passkey': '添加通行密钥',
  'Use a Passkey saved on your device or password manager.': '使用保存在设备或密码管理器中的通行密钥。',
  'Passkeys are optional. Your password and email recovery remain available.': '通行密钥是可选的，你仍可使用密码登录和邮箱找回。',
  'No Passkeys added yet.': '尚未添加通行密钥。',
  'Passkey {number}': '通行密钥 {number}',
  'Added {date}': '添加于 {date}',
  'Remove': '移除',
  'Remove Passkey {name}': '移除通行密钥 {name}',
  'Remove Passkey {display_name}': '移除通行密钥 {display_name}',
  'Remove this Passkey from your account? You can add it again later.': '从账号中移除此通行密钥？之后可以重新添加。',
  'Confirm removal': '确认移除',
  'Cancel': '取消',
  'Add another sign-in method before removing your last Passkey.': '请先添加其他登录方式，再移除最后一个通行密钥。',
  'The Passkey form is incomplete. Please start again.': '通行密钥表单不完整，请重新开始。',
  'This browser cannot use Passkeys here. You can still use your password.': '当前浏览器无法在此使用通行密钥，你仍可使用密码登录。',
  'Passkey request cancelled or timed out. Try again or use your password.': '通行密钥请求已取消或超时，请重试或使用密码。',
  'This Passkey is already registered. Use another authenticator.': '此通行密钥已添加，请使用其他验证器。',
  'Passkeys are unavailable on this address. Use your password and contact support.': '此地址无法使用通行密钥，请使用密码登录并联系支持人员。',
  'Unable to use this Passkey. Try again or use your password.': '无法使用此通行密钥，请重试或使用密码。',
  'Unable to confirm this Passkey update. Check your Passkeys before trying again.': '无法确认通行密钥更新结果，请先检查当前通行密钥，再决定是否重试。',
  'Create an account with a password first, then add a passkey in account settings.': '请先使用密码创建账号，再在账号设置中添加通行密钥。',
  'Sign in with an active account and verify your current email before managing passkeys.': '请使用有效账号登录并验证当前邮箱，再管理通行密钥。',
  'Passkey verification is temporarily unavailable. Please try again.': '通行密钥验证暂时不可用，请稍后重试。',
  'Try again': '重试',
  'Start again': '重新开始',
  'No sign-in method is available. Please start again.': '暂无可用的登录方式，请重新开始。',
  'Account help': '账号帮助',
  'New to TOGAPhotos?': '还没有 TOGAPhotos 账号？',
  'Create an account': '创建账号',
  'Forgot password?': '忘记密码？',
  'Already have an account?': '已有账号？',
  'Back to sign in': '返回登录',
  'Sign out and use another account': '退出并使用其他账号',
  'The authentication service returned an invalid redirect. Please try again.': '认证服务返回的跳转地址无效，请重试。',
  'Unable to confirm your session. Please try again.': '无法确认登录状态，请重试。',
  'This form has expired. A new form is ready for you to try again.': '表单已过期，请使用新表单重试。',
  'Unable to create a new form. Please try again.': '无法创建新表单，请重试。',
  'Unable to complete this request. Please try again.': '无法完成请求，请重试。',
  'Your password has been updated.': '密码已更新。',
  'Your account has been updated.': '账号信息已更新。',
}
